export const dataContainerStyles = {
    borderRadius: 12,
    boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
    background: "var(--gray-99, #FCFCFC)",
    padding: "36px 15px",
  };